import { createContext } from 'react'

export const AsciiContext = createContext()
